<div class={$$props.class} id="about">
  <left>
    <h1 style="font-size: 8vw;">about me</h1>
    <p style="font-size: 4vw;">I'm a person</p>
  </left>
  <right>
    <p id="content">
      Insert<br />
      Placeholder<br />
      Here
    </p>
  </right>
</div>

<style>
  #about * {
    margin: 0 0.5vw;
  }
  left {
    text-align: right;
    width: 55vw;
  }
  right {
    width: 45vw;
  }
  right p {
    font-size: 2vw;
    flex-wrap: wrap;
  }
</style>
